/**
 * The Dashboard's What's new card (TOADO-731): the current release's headline
 * changes, kept here and updated with each release, so nothing is fetched and
 * nothing can break. A person dismisses it for `release`; a new `release`
 * shows it again. `notesUrl` is left out until the full notes have a home.
 */
export const WHATS_NEW: { release: string; items: string[]; notesUrl?: string } = {
  release: '0.4.0',
  items: [
    'Get started walks you through Toado: a tour of your workspace and board, setting up the extension, and connecting an agent.',
    'An agent can ask the person who reported a ticket a question: the ticket moves to Needs reply and waits for their answer.',
    'Write how your team works once, on Board workflow, and every agent connected to Toado reads it when it opens a ticket.',
    'MCP setup checks that your agent is connected, from a read Toado sees, and the widget setup ends with a test report.',
    'A clearer recording start: a guide before you begin, and the extension page says whether Toado sees your extension.',
  ],
};
